module.exports = __webpack_public_path__ + "img/illustrations-fail.a8740522.svg";